export default "__VITE_ASSET__BD1Z5fA2__"